module.exports = new __parcel__URL__("location-light.9d9cfd0a.svg").toString();